import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Blocks from './components/bbcode/blocks';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

class FrontEndRadioInvite extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      service: {
				status: false,
        id: 0,
				channel: this.props.channel || undefined,
				name: ''
			},
      channel: {},
      fullname: '',
      apply: 0
		};
    this.setCookie = this.setCookie.bind(this);
    this.apply = this.apply.bind(this);
  };

  async componentDidMount() {
    const value = this.context;
    const getUser = await useracc();
    value.setUser( getUser );
    value.setTheme( '/themes/default-dark.css' );
    EventEmitter.emit('/client', {data: 'no value'});
		EventEmitter.emit('/page', {data: 'radio'});

    let params = new URLSearchParams();
    if( this.state.service.channel ) params.append('channel', this.state.service.channel);
    const x = await postApi(`/v3/frontend/radio`, params);
    console.log(x.data);

    if( x.data.length > 0 ) {

      let apply = 0;
      if( x.data[0]?.joined === true ) {
        apply = 3;
      } else if( x.data[0]?.applied===true )  {
        apply = 2;
      }
      //radio[0].applied = true;

      this.setState({status: true, channel: x.data[0], apply, fullname: x.data[0].fullname?x.data[0].fullname:''});
      this.setCookie();
    } else {

    }

    
  }

	componentWillUnmount() {
	}


  async setCookie() {
    let date = new Date();
		date.setTime(date.getTime() + 60 * 60 * 1000);
    document.cookie = `returnFixed=${window.location.href}; domain=.ultrastream.io; expires:${date.toUTCString()}; path=/`;
  }

  
	async apply() {
    let apply = this.state.apply;
    apply = 1;
    this.setState({apply},(async ()=>{

      let params = new URLSearchParams();

      
      
      let djing = document.getElementById('djing');
      let broadcasting = document.getElementById('broadcasting');
      //console.log(, );
      
      params.append('service', this.state.channel.id);
      params.append('fullname', document.getElementById('fullname').value);
      params.append('facebook', document.getElementById('facebook').value);

      params.append('djing', djing.options[djing.selectedIndex].text);
      params.append('broadcasting', broadcasting.options[broadcasting.selectedIndex].text);

      params.append('previous', document.getElementById('previous').value);
      await putApi(`/v3/frontend/radio`, params);

      apply = 2;
      this.setState({apply});

    }));
    
  }

	render() {
    const user = this.context;
    //console.log(user.user?.user?.id);
		return (
      <>
        {this.state.status === true &&
        
    			<div className="landing-page-wrapper">
            {Object.values(this.state.channel).length > 0 ?
              <div id="landing-page-wrapper" className="main-content landing-main">
        
                <div className="landing-banner" id="home">
                  <section className="section">
                    <div className="container main-banner-container">
                      <img src="../assets/images/media/landing/5.png" alt="img" className="banner-png" />
                      <img src="../assets/images/media/landing/3.png" alt="img" className="banner-png1" />
                      <img src="../assets/images/media/landing/4.png" alt="img" className="banner-png2" />
                      <img src="../assets/images/media/landing/6.png" alt="img" className="banner-png3" />
                      <div className="row justify-content-center">
                        <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12">
                          <div className="py-lg-5 text-center">
                            <p className="landing-banner-heading text-fixed-white mb-1">Join <span className="">{this.state.channel.title}</span></p>
                            <div className="fs-16 mb-4 text-fixed-white op-8 px-4">Velvet - Now you can use this admin template to design stunning, good and well well-structured dashboards that will wow your target viewers or users to no end.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>

                <section className="section section-background section-style" id="contact">
                  <div className="container text-center">
                    <p className="fs-12 fw-semibold text-primary mb-1"><span className="landing-section-heading">JOIN OUR TEAM</span></p>
                    <h4 className="fw-semibold mb-2">Have any questions ? We would love to hear from you.</h4>
                    <p className="text-muted fs-15 mb-5 fw-normal">You will require an ultrastream.io account before being able to contact this radio station.</p>


                    <div className="row text-start justify-content-center">
                      <div className="col-xxl-10 col-lg-12 col-md-12 col-sm-12">
                        <div className="card custom-card card-style-angle border">
                          <Row className="gx-0 p-2">
                            <div style={{width: 200}}>
                              <img src={`https://cloud.ultrastream.io/images/${this.state.channel.avatar}`} width="95%" />
                            </div>
                            <Col>
                              <h5 className="fw-semibold mx-1">{this.state.channel.title}</h5>
                              <hr />
                              
                              <Blocks blocks={this.state.channel.description} />
                              
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>



                    <div className="row text-start justify-content-center">
                      <div className="col-xxl-10 col-lg-12 col-md-12 col-sm-12">
                        <div className="card custom-card contactus-form overflow-hidden">
                          <div className="card-body p-4">
                            <Row className="gx-0 justify-content-center">
                              <div className="col-xl-5 p-0">
                                <div className="p-3">
                                  <h5 className="card-title mb-1">Contact Information</h5>
                                  <p className="text-muted mb-0">Please complete the form and the team will be get back to you</p>
                                </div>
                                
                              
                              </div>
                            </Row>
                            {user.user?.user &&
                              <>
                                {user.user?.user?.id === 1 ?
                                  <Row className="gx-0 justify-content-center">
                                    <div className="col-xl-7 border rounded-3  p-3">
                                      <div className="row gy-3">
                                        <Col>
                                          You'll need to create an account or login to join this team, its free to sign up.<br /><br />
                                          <a href="https://portal.ultrastream.io/"><Button>Login</Button></a>
                                        </Col>
                                      </div>
                                    </div>
                                  </Row>
                                :
                                  <Row className="gx-0 justify-content-center">
                                    <div className="col-xl-7 border rounded-3  p-3">
                                      <div className="row gy-3">
                                        <Col xs={12}>
                                          <label htmlFor="fullname" className="form-label ">Full Name :</label>
                                          <input type="text" className="form-control" id="fullname" placeholder="Enter Name" defaultValue={this.state.fullname} />
                                        </Col>
                                        <Col xs={12}>
                                          <label htmlFor="facebook" className="form-label ">Provide a link to your own facebbok profile page and please don't include a link to a page<br />Facebook Profile : </label>
                                          <input type="text" className="form-control" id="facebook" placeholder="Facebook Profile Page" />
                                        </Col>
                                        <Col xs={12}>
                                          <label className="form-label ">Please give us an overview of the experience you have in DJing</label>
                                          <select className="form-select form-select-sm" id="djing">
                                            <option value="0">No experience DJing</option>
                                            <option value="1">Less than 5 years experience</option>
                                            <option value="2">More than 5 years experience</option>
                                          </select>
                                        </Col>
                                        <Col xs={12}>
                                        <label className="form-label ">Please give us an overview of the experience you have in Broadcasting</label>
                                          <select className="form-select form-select-sm" id="broadcasting">
                                            <option value="0">No broadcasting experience</option>
                                            <option value="1">Less than 5 years experience</option>
                                            <option value="2">More than 5 years experience</option>
                                          </select>
                                        </Col>
                                        <Col xs={12}>
                                          <label htmlFor="previous" className="form-label ">
                                            Provide a link to where we can obtain your previous mixes. Video is not essential<br />
                                            Prvious Mix :</label>
                                          <input type="text" className="form-control" id="previous" placeholder="Previous mix" />
                                        </Col>
                                      </div>
                                      <div className="card-footer border-top-0 ps-0 pb-0 mt-1">
                                        {this.state.apply === 3 &&
                                          <div className="text-start">
                                            You are all ready part of this group.
                                          </div>
                                        }
                                        {this.state.apply === 2 &&
                                          <div className="text-start">
                                            Thank you for applying and one of the team admins will get back to you.
                                          </div>
                                        }
                                        {this.state.apply === 0 &&
                                          <div className="text-start">
                                            <button type="button" aria-label="button" className="btn btn-primary btn-wave" disabled={this.state.apply===1} onClick={this.apply}>{this.state.apply===1?'Processing':'Apply'}</button>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </Row>
                                }
                              </>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            :
              <>
                Not active
              </>
            }
    
    
        
    
            
          </div>
        }
      </>
		)
	}
}

const RadioInvite = props => {
  const { channel } = useParams();
  return <FrontEndRadioInvite channel={channel} {...props} />
}
export default RadioInvite;